import { atom } from "@reatom/framework";
import { withLocalStorage } from "@reatom/persist-web-storage";

export const paymentModalAtom = atom(false, "paymentModal").pipe(
  withLocalStorage("paymentModal"),
);
